import React from 'react';
import { FileTextOutlined } from '@ant-design/icons';
import './orderXV4Scan.css';

// Shows the actual document (image/PDF) with a "scanning" line overlay while
// it's being read/processed — ported from OrderX v3's doc-scan-wrap effect.
// Used both on Step 1 (a just-attached local file, previewed via object URL)
// and during async processing (a stored file, previewed via the backend).
const DocumentScanPreview = ({
  previewUrl,
  previewType,
  filename,
  scanning,
  tabular,
  minHeight,
  scanLabel,
}) => {
  const type = String(previewType || '').trim().toLowerCase();
  const isPdf = type === 'application/pdf';
  const isImage = type.startsWith('image/');
  const label = scanLabel || (tabular ? 'Reading rows...' : 'Scanning document...');

  return (
    <div className="orderx-doc-scan-wrap">
      {previewUrl && isPdf ? (
        <iframe title={filename || 'Document preview'} src={previewUrl} className="orderx-doc-frame" style={minHeight ? { minHeight } : undefined} />
      ) : (
        <div
          className="orderx-doc-preview"
          style={{
            backgroundImage: previewUrl && isImage ? `url(${previewUrl})` : 'none',
            ...(minHeight ? { minHeight } : null),
          }}
        >
          {!(previewUrl && isImage) && (
            <div className="orderx-doc-fallback text-muted">
              <FileTextOutlined style={{ fontSize: 28 }} />
              <span className="small text-truncate" style={{ maxWidth: 200 }}>{filename || 'Document'}</span>
            </div>
          )}
        </div>
      )}

      {scanning && (
        <div
          className={`orderx-scanning-overlay ${tabular ? 'orderx-scanning-overlay--tabular' : ''}`}
          aria-hidden="true"
        >
          <div className="orderx-scanning-line" />
          <div className="orderx-scanning-label">{label}</div>
        </div>
      )}
    </div>
  );
};

export default DocumentScanPreview;
